import { useCallback, useEffect, useRef, useState } from 'react';

const useResendCooldown = (cooldownSeconds = 60) => {
  const [secondsLeft, setSecondsLeft] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => () => clearInterval(intervalRef.current), []);

  const start = useCallback(() => {
    clearInterval(intervalRef.current);
    setSecondsLeft(cooldownSeconds);
    intervalRef.current = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  }, [cooldownSeconds]);

  return { secondsLeft, isActive: secondsLeft > 0, start };
};

export default useResendCooldown;
